import { Type, type Static } from '@sinclair/typebox';
import { ScopeStatusSchema } from './scope.schema';

export const PostScopeBodySchema = Type.Object(
  {
    name: Type.String({
      minLength: 1,
      maxLength: 255,
      description: 'An internal name used to identify the Scope.',
    }),
    reference: Type.Optional(
      Type.String({
        minLength: 1,
        maxLength: 255,
        description: 'Optional metadata used to map the Scope to an external resource. Must be unique in the Application.',
      }),
    ),
  },
  { additionalProperties: false },
);

export const PatchScopeBodySchema = Type.Object(
  {
    name: Type.Optional(
      Type.String({
        minLength: 1,
        description: 'The new internal name of the Scope.',
      }),
    ),
    reference: Type.Optional(
      Type.Union([Type.String({ minLength: 1 }), Type.Null()], {
        description: 'The new external reference of the Scope. Must be unique in the Application. Set to `null` to remove it.',
      }),
    ),
    status: Type.Optional(ScopeStatusSchema),
  },
  { additionalProperties: false },
);

export const ListScopesQuerySchema = Type.Object({
  offset: Type.Optional(Type.String({ description: 'The number of Scopes to skip for pagination.' })),
  limit: Type.Optional(Type.String({ description: 'The maximum number of Scopes to return.', default: '20' })),
  status: Type.Optional(ScopeStatusSchema),
  search: Type.Optional(Type.String({ description: 'Filter scopes by name or reference.' })),
});

export type PostScopeBody = Static<typeof PostScopeBodySchema>;
export type PatchScopeBody = Static<typeof PatchScopeBodySchema>;
export type ListScopesQuery = Static<typeof ListScopesQuerySchema>;
